$(document).ready(function() {
  var date_count = 0
  $('#send-email').hide();
  $('.daterange').on('apply.daterangepicker', function(ev, picker) {
    var date_1 = new Date(picker.startDate)
    var date_2 = new Date(picker.endDate)

    var days = (date_2 - date_1) / (1000 * 60 * 60 * 24);
    date_count = Math.round(days)
    $('#date_count').attr('value', date_count)

    if (date_count >= 32) {
      $('#Send_To_Email_').attr('checked', true)
      $('#send-email').show()
      $('#Send_To_Email_').change(function() {
        var checked = $(this).is(':checked')
        $(this).val(checked)
        if (checked) {
          addModal()
        } else {
          deleteModal()
        }
      }).change()
    } else {
      $('#Send_To_Email_').attr('checked', false)
      $('#send-email').hide()
    }
  });

  $('#selected_report').change(function() {
    var selected = $(this).find(":selected").val()
    if (selected == '') {
      deleteModal();
    }
  }).change();

  $('.checkbox_tag').hide();
  $('#selected_report').change(function() {
    var selected = $(this).find(":selected").val()
    if (selected == 'debtors') {
      $('.checkbox_tag').show();
    } else {
      $('.checkbox_tag').hide();
      $('#Export_All').prop('checked', false);
    }
  })

  $('#submit_search').click(function() {
    if ($('#selected_report').find(":selected").val() == 'debtors') {
      if ($('#Export_All').is(':checked') || $('#Send_To_Email_').is(':checked')) {
        addModal();
      } else {
        $('#Export_All').attr('checked', false)
        deleteModal();
      }
    } else if ($('#date_count').val() <= 31) {
      deleteModal();
    }
  });

  // disabled after click modal export
  $('form').submit(function() {
    var check_email = isEmail($('.email-modal-export').val());
    if (check_email) {
      $('.button-export').prop('disabled', true);
    } else {
      $('.button-export').removeAttr('disabled');
    }
  })

  function isEmail(email) {
    var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
    return regex.test(email);
  }

  function deleteModal() {
    $('#email').prop('required', false)
    $('#submit_search').removeAttr('type')
    $('#submit_search').removeAttr('data-toggle')
    $('#submit_search').removeAttr('data-target')
    $('#submit_search').attr('type', 'submit')
  }

  function addModal() {
    $('#email').prop('required', true)
    $('#submit_search').removeAttr('type')
    $('#submit_search').attr('data-toggle', 'modal')
    $('#submit_search').attr('data-target', '#exampleModal')
    $('#submit_search').attr('type', 'button')
    return true
  }
});